import { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest, isInIframe } from './msalConfig';

export default function LoginPage() {
  const { instance } = useMsal();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setError(null);
    setLoading(true);
    try {
      if (isInIframe()) {
        // Redirect flow doesn't work inside iframes — use popup
        const response = await instance.loginPopup(loginRequest);
        if (response?.account) {
          instance.setActiveAccount(response.account);
        }
      } else {
        // Standalone — use redirect flow (full-page redirect)
        await instance.loginRedirect(loginRequest);
      }
    } catch (err) {
      setLoading(false);
      if (err instanceof Error && err.message.includes('user_cancelled')) {
        setError('Sign-in was cancelled. Please try again.');
      } else {
        setError(err instanceof Error ? err.message : 'Authentication failed. Please try again.');
      }
    }
  };

  return (
    <div className="min-h-screen bg-[#0A1628] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* Logo / Branding */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-gold-primary to-gold-pressed flex items-center justify-center mx-auto mb-4 shadow-lg">
            <span className="text-navy-primary font-black text-2xl">N</span>
          </div>
          <h1 className="text-2xl font-bold text-text-heading tracking-wider">
            <span className="text-gold-primary">AFN</span> NEXUS
          </h1>
          <p className="text-text-muted text-sm mt-1">AI Command Center</p>
        </div>

        {/* Login Card */}
        <div className="bg-navy-card rounded-xl border border-navy-border p-6 shadow-2xl">
          <h2 className="text-lg font-semibold text-text-heading text-center mb-6">Sign in to continue</h2>

          {error && (
            <div className="mb-4 p-3 rounded-lg bg-red-500/10 border border-red-500/20 text-red-400 text-sm">
              {error}
            </div>
          )}

          <button
            onClick={handleLogin}
            disabled={loading}
            className="w-full flex items-center justify-center gap-3 px-4 py-3 rounded-lg bg-[#2F2F2F] hover:bg-[#3b3b3b] text-white font-medium text-sm transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <svg width="20" height="20" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
              </svg>
            )}
            Sign in with Microsoft
          </button>

          <p className="text-xs text-text-muted text-center mt-4">
            Use your AFN corporate account to sign in
          </p>
        </div>
      </div>
    </div>
  );
}
